import React from 'react';
import ReactDOM from 'react-dom';
import indexRoutes from 'router/index';
import * as serviceWorker from 'serviceWorker';
// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import {makeStyles, ThemeProvider as MuiThemeProvider} from '@material-ui/core/styles'
import theme from "assets/jss/theme.js";
import "assets/css/index.css";

import {HashRouter as Router, Route, Switch} from 'react-router-dom';

import {createStore} from 'redux'
import reducer from 'reducers'
import {Provider} from 'react-redux'
import useLoading from "hooks/useLoading";
import Spinner from "components/Spinner";
import Button from "components/CustomButtons";
import CustomDialog from "components/CustomDialog";
import useError from "hooks/useError";
import usePopup from "hooks/usePopup";

import commonStyle from "assets/jss/common.js"

const useStyles = makeStyles({
  ...commonStyle,
});

const store = createStore(reducer);
process.env.NODE_ENV !== "development" && (console.log = () => {});

function Index() {
    const {loadingCount} = useLoading();
    const {error, closeError} = useError();
    const {popup, closePopup} = usePopup();
    const classes = useStyles();

    return(
        <React.Fragment>
            {loadingCount > 0 ? <Spinner /> : null}
            <Router>
                <Switch>
                    {indexRoutes.map((prop, key) => {
                        return <Route path={prop.path} exact={prop.exact} component={prop.component} key={key} />;
                    })}
                </Switch>
            </Router>
            <CustomDialog
                open={error.show}
                onClose={()=> closeError()}
                dialogTitle={"エラー"}
                dialogContent={
                    <div style={{textAlign:"center", overflowWrap:"break-word",whiteSpace: 'pre'}}>{error.text}</div>
                }
                dialogActions={
                    <div>
                        <Button onClick={()=> closeError()}>
                            Close
                        </Button>
                    </div>
                }
            />
            <CustomDialog
                open={popup.show}
                onClose={()=> closePopup()}
                dialogTitle={popup.title}
                dialogContent={
                    <div className={classes.textCenter}>
                        <div>{popup.text}</div>
                    </div>
                }
                dialogActions={
                    <div>
                        <Button onClick={()=> closePopup()}>
                            Close
                        </Button>
                    </div>
                }
            />
        </React.Fragment>
    )
}

ReactDOM.render(
    (
        <MuiThemeProvider theme={theme}>
            <Provider store={store}>
                <Index />
            </Provider>
        </MuiThemeProvider>
    ),
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
